import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import * as wjcGrid from '@grapecity/wijmo.grid';
import { UndefinedOrNull } from 'ix-ng-static-utils';
import { Paginator, PaginatorState } from 'primeng/paginator';

@Component({
  selector: 'lib-flexgrid-paginator',
  templateUrl: './flexgrid-paginator.component.html',
  styleUrls: ['./flexgrid-paginator.component.css'],
  imports: [Paginator],
})
export class FlexgridPaginatorComponent implements OnInit {
  defaultNumRows = 1000;
  rowsPerPageOptions: number[] = [50, 100, 1000, 10000];

  @Input() flexGrid: wjcGrid.FlexGrid | UndefinedOrNull | undefined;
  @Input() set defaultPageSize(value: number) {
    this.defaultNumRows = value;
    this.flexGrid!.itemsSource.pageSize = value;
  }
  @Output()
  pageChanged = new EventEmitter<void>();

  get totalRecords(): number {
    return this.flexGrid?.itemsSource?.totalItemCount;
  }

  onPageChange(event: PaginatorState) {
    if (this.flexGrid && event.rows) {
      this.defaultNumRows = event.rows;
      this.flexGrid.itemsSource.pageSize = event.rows;
      this.flexGrid.itemsSource.moveToPage(event.page);
      this.pageChanged.emit();
    }
  }

  ngOnInit(): void {
    if (this.flexGrid) {
      this.flexGrid.itemsSource.pageSize = this.defaultNumRows;

      // v primeru več kot 1000 zapisov v flexgridu
      // kot zadnjo opcijo dodamo število vseh zapsiov
      if (this.flexGrid?.itemsSource?.totalItemCount > 1000) {
        this.rowsPerPageOptions.push(this.flexGrid?.itemsSource?.totalItemCount);
      }

      this.pageChanged.emit();
    }
  }
}
